export enum ModulesSuggestions {
  Administrative = "administrative",
  Branch = "branch",
  Starred = "starred",
  Folder = "folder",
  Slug = "slug",
  Label = "label",
  ProjectRoot = "projectRoot",
  Repository = "repository",
  Integration = "integration",
  Space = "space",
  WorkerPool = "workerPool",
  CreatedAt = "createdAt",
  ModuleProvider = "moduleProvider",
}

export const SEARCH_MODULES_SUGGESTIONS_DICTIONARY: Record<string, string> = {
  [ModulesSuggestions.Space]: "space",
  [ModulesSuggestions.Slug]: "ID",
  [ModulesSuggestions.Label]: "Labels",
  [ModulesSuggestions.ProjectRoot]: "Project root",
  [ModulesSuggestions.WorkerPool]: "Worker pool",
  [ModulesSuggestions.Integration]: "Source code integration",
  [ModulesSuggestions.CreatedAt]: "Created at",
  [ModulesSuggestions.ModuleProvider]: "Module provider",
  [ModulesSuggestions.Starred]: "Favorite",
};

export const SORT_ITEM_ORDER = ["favorite", "name", "space", "createdAt"];
